{
  "newFeature": "Die optimierte Anwendungsauswahl enthält jetzt nur mehr für Sie aktivierte Apps, die in einer einzigen Liste aufgeführt werden.",
  "newLayout": "Neues Layout",
  "ok": "OK"
}
